export default {
  // GET Requests //

  // Gets all data in training
  async getMeetings(context) {
    const token = context.rootGetters["authData/token"];
    const companyId = context.rootGetters["userData/companyId"];
    let response;

    try {
      response = await fetch(
        process.env.VUE_APP_NODE_SERVER +
          "/meetings/retrieve-by-company/" +
          companyId,
        {
          method: "GET",
          headers: { Authorization: "Bearer " + token },
        }
      );
      response = await response.json();
    } catch (err) {
      return 500;
    }

    // create learning object
    var meetingsObject = [];
    response.meetings.forEach((meeting) => {
      meetingsObject.push({
        meetingId: meeting.meetingId,
        userId: meeting.userId,
        recipients: meeting.recipients,
        title: meeting.title,
        items: meeting.items,
        datetime: meeting.datetime,
        location: meeting.location,
        meetingType: meeting.meetingType,
        details: meeting.details,
        created: meeting.created,
      });
    });

    context.commit("meetings", meetingsObject);
    context.commit("meetingsTimestamp");

    return 200;
  },
  // POST Requests //

  // Add new meeting
  async postMeeting(context, payload) {
    const token = context.rootGetters["authData/token"];
    const companyId = context.rootGetters["userData/companyId"];
    let response;

    try {
      response = await fetch(
        process.env.VUE_APP_NODE_SERVER + "/meetings/add",
        {
          method: "POST",
          mode: "cors",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          body: JSON.stringify({
            companyId: companyId,
            userId: payload.userId,
            recipients: payload.recipients,
            meetingType: payload.meetingType,
            datetime: payload.datetime,
            items: payload.items,
            location: payload.location,
            details: payload.details,
            title: payload.title,
          }),
        }
      );
      response = await response.json();
    } catch (err) {
      return { status: 500 };
    }

    let meetingFound = false;
    var meetingsPayload = context.state.meetings;
    for (let i = 0; i < meetingsPayload.length; i++) {
      if (meetingsPayload[i].meetingId == response.meetingId) {
        meetingsPayload[i].meetingId = response.meetingId;
        meetingsPayload[i].userId = response.userId;
        meetingsPayload[i].recipients = response.recipients;
        meetingsPayload[i].title = response.title;
        meetingsPayload[i].items = response.items;
        meetingsPayload[i].datetime = response.datetime;
        meetingsPayload[i].location = response.location;
        meetingsPayload[i].meetingType = response.meetingType;
        meetingsPayload[i].details = response.details;
        meetingFound = true;
        break;
      }
    }

    if (!meetingFound) {
      meetingsPayload.push({
        meetingId: response.meetingId,
        userId: response.userId,
        recipients: response.recipients,
        title: response.title,
        items: response.items,
        datetime: response.datetime,
        location: response.location,
        meetingType: response.meetingType,
        details: response.details,
        created: response.created,
      });
    }

    context.commit("meetings", meetingsPayload);

    return {
      status: 201,
      meetingId: response.meetingId,
    };
  },
  // DELETE Requests //

  // Delete meeting
  async deleteMeeting(context, meetingId) {
    const token = context.rootGetters["authData/token"];
    const companyId = context.rootGetters["userData/companyId"];
    try {
      await fetch(process.env.VUE_APP_NODE_SERVER + "/meetings/remove", {
        method: "DELETE",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
        body: JSON.stringify({
          meetingId: meetingId,
          companyId: companyId,
        }),
      });
    } catch (err) {
      return 500;
    }

    var meetingsPayload = context.state.meetings.filter((meeting) => {
      return meeting.meetingId != meetingId;
    });

    context.commit("meetings", meetingsPayload);

    return 201;
  },
  // Functions //

  // Delete meeting by module
  deleteMeetingsByModule(context, moduleId) {
    var meetingsPayload = context.state.meetings.filter((meeting) => {
      meeting.meetingType == "competency_test" &&
        meeting.details.moduleId != moduleId;
    });

    context.commit("meetings", meetingsPayload);

    return;
  },
  // Delete meeting by enrollemnt
  deleteMeetingsByEnrollment(context, enrollmentId) {
    var meetingsPayload = context.state.meetings.filter((meeting) => {
      meeting.meetingType == "competency_test" &&
        meeting.details.enrollmentId != enrollmentId;
    });

    context.commit("meetings", meetingsPayload);

    return;
  },
  // Delete meeting by competency test
  deleteMeetingsByCompetencyTest(context, competencyId) {
    var meetingsPayload = context.state.meetings.filter((meeting) => {
      meeting.meetingType == "competency_test" &&
        meeting.details.competencyId != competencyId;
    });

    context.commit("meetings", meetingsPayload);

    return;
  },
  // Reset timestamp
  meetingsTimestampReset(context) {
    context.commit("meetingsTimestampReset");
  },
};
